export default {"src":"/_next/static/media/op-dev.3180321f.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};